// feedbackLuzes.js

let statusDasLuzesFlex35 = [];
let statusDasLuzesFlex8 = [];

export async function getLuzesStatusFlex8() {

  try {
    const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/statusLuzesFlex8`);
    const data = await response.json();
    statusDasLuzesFlex8 = [...data];
  } catch (error) {
    console.error("Erro na requisição HTTP GET:", error);
  }

  return statusDasLuzesFlex8;
}

export { statusDasLuzesFlex35, statusDasLuzesFlex8 };